/**
 * Created by shiying on 2017/4/29.
 */

var config = require("./commons/config.js")
var helper = require("./commons/helper.js")
var extend = require("extend")

// 导入默认配置
config.defaultConfigs.urls["orderCenter"] = {
    orderList : 'orderCenter/orderList.json'
};


var orderList = function(parmars, reload) {
    var defaultParmar = {
        channel : undefined,
        closeStatus : undefined,
        pageNo : 1,
        pageSize : 20
    };
    return helper.reqHelper(
        "orderCenter", "orderList",
        extend({}, defaultParmar, parmars), reload,
        function(obj) {
            return obj && obj.FLAG == '0'
        });
};


module.exports = {
    orderList : orderList
}



//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/fdapi/orderCenter.js
// module id = 17
// module chunks = 0